import PersonViewModel from "./personViewModel";
import { interfaces } from "inversify";
import Person from "../../../models/person";
import LocalizationService from "../../../services/localizationService";
import GDPRViewModel from "../../common/gdpr/GDPRViewModel";

export default class ApplicantPersonViewModel extends PersonViewModel {
  gdprViewModel?: GDPRViewModel;

  constructor(
    public person: Person,
    protected localizationService: LocalizationService,
    gdprVMFactory: ReturnType<typeof GDPRViewModel.Factory>,
    public showBirthdate: boolean,
    GDPRMessage?: string
  ) {
    super(person, localizationService);
    person._validateBirthDate = showBirthdate;
    if (GDPRMessage) {
      this.gdprViewModel = gdprVMFactory(GDPRMessage);
    }
  }

  static Factory({ container }: interfaces.Context) {
    return (person: Person, GDPRMessage?: string, showBirthdate = true) =>
      new ApplicantPersonViewModel(
        person,
        container.get(LocalizationService),
        container.get(GDPRViewModel.Factory),
        showBirthdate,
        GDPRMessage
      );
  }
}
